document.addEventListener('DOMContentLoaded', () => {
  initViewTransitions();
});

function initViewTransitions() {
  if (!document.startViewTransition) return;
  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      link.target === '_blank'
    ) return;
    link.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      document.startViewTransition(() => {
        window.location.href = href;
      });
    });
  });
}

/*
 * Add-to-cart is handled in ONE place: snippets/cart-drawer.liquid.
 * It intercepts every theme add-to-cart form, posts to the cart, opens the
 * drawer, and updates the header count. The previous duplicate handler that
 * lived here caused items to be added twice on the product page (both this
 * script and the drawer intercepted the same #product-form submit). Keep
 * cart behavior consolidated in the drawer snippet — do not re-add a second
 * submit listener here.
 */
